import styled from 'styled-components';
import BottomSheet from '@components/BottomSheet';

const BottomSheetStyled = styled(BottomSheet)`
  z-index: ${({ theme }) => theme.constants.zIndex.secondHeader + 1};
`;

export default BottomSheetStyled;
